import { ReactComponent as ChatPaymentBadge } from '@assets/images/app/chat-and-payment.svg';
import { ReactComponent as DirectPaymentBadge } from '@assets/images/app/direct-payment.svg';
import { useAuthentication } from '@hooks/authentication';
import { ProductModel } from '@models/product';
import { discountedAmountBy, getAppliedMembership } from '@utils/common';
import React from 'react';
import { PurchaseBenefits } from './PurchaseBenefits';

export const ProductSummary: React.FC<{ data: ProductModel; closed?: boolean }> = (props) => {
  const { myMembership } = useAuthentication();
  const data = props.data;
  const appliedMembership = getAppliedMembership(data, myMembership);

  if (data?.applyPeriodDiscount && data?.discountInfo?.discountedFee) {
    const today = new Date();
    if (
      data?.discountInfo?.discountStartDate &&
      data?.discountInfo?.discountEndDate &&
      new Date(data?.discountInfo?.discountStartDate) < today &&
      new Date(data?.discountInfo?.discountEndDate) > today
    ) {
      data.fee = data?.discountInfo?.discountedFee || 0;
      data.discount = `${Math.floor(100 - (data.fee / data?.originFee) * 100)}%`;
    }
  }

  let amount = data?.fee || 0;
  const originAmount = data?.originFee || amount;
  if (data && appliedMembership?.hideDiscountPercent) {
    amount = discountedAmountBy(data?.fee || 0, appliedMembership?.discountPercent || 0);
    data.discount = `${Math.floor(100 - (amount / originAmount) * 100)}%`;
  }

  return (
    <div style={{ padding: '24px 16px' }}>
      <div>
        {data.saleType === 'class' && (
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              color: 'var(--Primary-95, #FF3D8F)',
              fontFamily: 'Pretendard',
              fontSize: '13px',
              fontStyle: 'normal',
              fontWeight: 400,
              marginBottom: '12px',
            }}>
            <ChatPaymentBadge />
            <div style={{ width: '1px', height: '10px', background: '#FFC5DD' }}></div>
            <div>희망 옵션 상담 후 구매 가능</div>
          </div>
        )}
        {data.saleType === 'commerce' && (
          <div
            style={{
              display: 'flex',
              gap: '6px',
              color: '#7950EF',
              fontFamily: 'Pretendard',
              fontSize: '13px',
              fontStyle: 'normal',
              fontWeight: 400,
              marginBottom: '12px',
            }}>
            <DirectPaymentBadge />
            <div style={{ width: '1px', height: '10px', background: '#D5C5FF' }}></div>
            <div>희망 옵션 바로 구매 가능</div>
          </div>
        )}
      </div>
      <div
        style={{
          marginTop: '12px',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          flex: '1px',
        }}>
        <div
          style={{
            color: 'var(--Neutral-90, #424242)',
            fontFamily: 'Pretendard',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 400,
          }}>
          {data?.title}
        </div>
      </div>
      <div
        style={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: '8px',
        }}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
          {data?.discount && data.discount.replace(/[^0-9]/g, '') !== '' && parseInt(data.discount) > 0 && (
            <div
              style={{
                color: props.closed ? '#B9BBBE' : 'var(--Primary-95, #FF3D8F)',
                fontFamily: 'Pretendard',
                fontSize: '22px',
                fontStyle: 'normal',
                fontWeight: 700,
                marginRight: '4px',
              }}>
              {data?.discount}
            </div>
          )}
          <div
            style={{
              fontFamily: 'Pretendard',
              fontSize: '22px',
              fontWeight: 'bold',
              color: props.closed ? '#B9BBBE' : '#242424',
            }}>
            {amount.toLocaleString()}
          </div>
          <div
            style={{
              fontFamily: 'Pretendard',
              fontSize: '14px',
              fontWeight: 'normal',
              color: props.closed ? '#B9BBBE' : '#242424',
              lineHeight: '26px',
            }}>
            원
            {/* {data?.showRegularTime && data?.regularTime && data?.regularTime > 0 ? ` / ${data?.regularTime}회` : <></>} */}
          </div>
          {data?.originFee && data.originFee > 0 && data.originFee !== data.fee ? (
            <div
              style={{
                fontFamily: 'Pretendard',
                marginLeft: '4px',
                textDecorationLine: 'line-through',
                color: props.closed ? '#B9BBBE' : '#b9bbbe',
                fontSize: '14px',
              }}>
              {`${data.originFee.toLocaleString()}원`}
            </div>
          ) : (
            <></>
          )}
        </div>
      </div>
      {appliedMembership?.hideDiscountPercent && (
        <div
          style={{
            color: 'var(--Semantic-Negative-100, #FC4242)',
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 700,
            marginTop: '4px',
            display: 'flex',
            alignItems: 'flex-end',
            lineHeight: '17px',
          }}>
          <div style={{ fontSize: '14px', fontWeight: 500, marginLeft: '4px' }}>멤버십 혜택가</div>
        </div>
      )}
      {appliedMembership && !appliedMembership.hideDiscountPercent && (
        <div
          style={{
            color: 'var(--Semantic-Negative-100, #FC4242)',
            fontFamily: 'Pretendard',
            fontStyle: 'normal',
            fontWeight: 700,
            marginTop: '4px',
            display: 'flex',
            alignItems: 'flex-end',
            lineHeight: '17px',
          }}>
          <div style={{ fontSize: '20px', lineHeight: '20px' }}>{`${discountedAmountBy(
            data?.fee || 0,
            appliedMembership.discountPercent || 0,
          ).toLocaleString()}`}</div>
          <div style={{ fontSize: '14px' }}>원</div>
          <div style={{ fontSize: '14px', fontWeight: 500, marginLeft: '4px' }}>멤버십 할인가</div>
        </div>
      )}
      {props.closed && (
        <div
          style={{
            marginTop: '12px',
            color: 'var(--Negative-40, #FC4242)',
            fontFamily: 'Pretendard',
            fontSize: '18px',
            fontStyle: 'normal',
            fontWeight: 400,
          }}>
          다음 오픈을 기다려주세요.
        </div>
      )}
      <PurchaseBenefits data={data} style={{ marginTop: '12px' }} />
    </div>
  );
};
